const HomePageQueryKeys = {
  all: ['home-page'],
};

export default HomePageQueryKeys;
